import classes from './UserProfilePanel.module.scss';

interface UserProfilePanelProps {
  userName: string;
  userStation: string;
  adGroups: string[];
  userDeptCode: string;
}

export const UserProfilePanel = ({userName, userStation, adGroups, userDeptCode}: UserProfilePanelProps) => {
  return (
      <div className={classes.panelbody}>
        <span className={classes.username}>{userName}</span>
        <span className={classes.label}>Station</span>
        <span className={classes.userstation}>{userStation === null || userStation === undefined || userStation === '' ? '---' : userStation}</span>
        <span className={classes.label}>AD Group</span>
        <div className={classes.adgroupcontainer}>
          {adGroups.length > 0 ? (
            adGroups.map((group, index) => (
              <span className={classes.adgroup} key={index}>
                {group}
              </span>
            ))
          ) : (
            <span className={classes.adgroup}>---</span>
          )}
        </div>
        <span className={classes.label}>Dept Code</span>
        <span className={classes.deptcode}> {userDeptCode === null || userDeptCode === undefined || userDeptCode === '' ? '---' : userDeptCode}</span>         
      </div>
  );
};